import { Howl } from 'howler';

interface ISessionItem {
  id: string;
  time: number;
}

class Alarm {
  alarmSound: Howl;
  speakingTexts = new Map<string, SpeechSynthesisUtterance>();

  constructor() {
    this.alarmSound = new Howl({
      src: ['/audio/alarm.mp3'],
      format: 'mp3',
      loop: false,
    });
  }

  playAlarm() {
    if (this.alarmSound && !this.alarmSound.playing()) {
      this.alarmSound.play();
    }
  }

  playText(text = '') {
    try {
      if (text && window.speechSynthesis) {
        this.alarmSound?.stop?.();
        if (!this.speakingTexts.has(text)) {
          const utterance = new SpeechSynthesisUtterance(text);
          this.speakingTexts.set(text, utterance);
          utterance.onend = () => {
            this.speakingTexts.delete(text);
          };
          utterance.onerror = () => {
            this.speakingTexts.delete(text);
          };
          window.speechSynthesis.speak(utterance);
        }
      } else {
        this.playAlarm();
      }
    } catch (error) {
      this.playAlarm();
    }
  }

  play(text = '', sessionId = '') {
    const now = Date.now();
    const sessionList = JSON.parse(localStorage.getItem('sessionList') || '[]').filter(
      (item: ISessionItem) => now - item.time < 1000 * 60 * 5,
    );
    if (sessionList.some((item: ISessionItem) => item.id === sessionId)) {
      if (text) {
        this.playText(text);
      } else {
        this.playAlarm();
      }
    } else if (!sessionList.length) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          new Notification('网点有异常事件发生', {
            icon: '/favicon.ico',
            body: text,
          });
        }
      });
    }
  }
}

const alarm = new Alarm();

export default alarm;
